import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AsyncPipe, NgClass, NgStyle } from '@angular/common';
import { Component, effect, inject, OnInit, Version } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterOutlet } from '@angular/router';
import { ADJUSTMENT_ITEMS } from '@app/adjustment/adjustment.routes';
import { APPRAISAL_ITEMS } from '@app/appraisal/appraisal.routes';
import { AUCTION_ITEMS } from '@app/auction/auction.routes';
import { CALL_CENTER_ITEMS } from '@app/call-center/call-center.routes';
import { FINANCE_ITEMS } from '@app/finance/finance.routes';
import { INVESTIGATION_ITEMS } from '@app/investigation/investigation.route';
import { LITIGATION_ITEMS } from '@app/litigation/litigation.route';
import { PERSONS_ITEMS } from '@app/persons/persons.routes';
import { PROCESSING_ITEMS } from '@app/processing/processisng.routes';
import { SALVAGES_ITEMS } from '@app/salvages/salvages.routes';
import { PageTitleService } from '@app/services/page-title.service';
import { THEFT_ITEMS } from '@app/theft/theft.routes';
import { version } from '@app/version';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faAngleDown, faRightFromBracket, faScrewdriverWrench } from '@fortawesome/pro-duotone-svg-icons';
import { AuthService } from '@nittenapps/auth';
import { BreadcrumbComponent, NavbarVerticalComponent, NavItem } from '@nittenapps/components';
import { CONFIG_ITEMS } from '@nittenapps/config';
import { KeycloakProfile } from 'keycloak-js';
import { map, Observable, shareReplay } from 'rxjs';

@Component({
  selector: 'app-navigation',
  imports: [
    AsyncPipe,
    BreadcrumbComponent,
    FaIconComponent,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatSidenavModule,
    MatToolbarModule,
    NavbarVerticalComponent,
    NgClass,
    NgStyle,
    RouterOutlet,
  ],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
})
export class NavigationComponent implements OnInit {
  readonly faAngleDown = faAngleDown;
  readonly faRightFromBracket = faRightFromBracket;
  readonly faScrwdriverWrench = faScrewdriverWrench;

  private breakpointObserver = inject(BreakpointObserver);
  pageTitleService = inject(PageTitleService);

  title: string = '';
  navbarFolded = true;
  navbarOpen = false;
  userProfile: KeycloakProfile | null = null;
  readonly navItems: NavItem[];
  readonly version = new Version(version);

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
    map((result) => result.matches),
    shareReplay(),
  );

  constructor(private authService: AuthService) {
    this.navItems = [
      ...PERSONS_ITEMS,
      ...FINANCE_ITEMS,
      ...CALL_CENTER_ITEMS,
      ...ADJUSTMENT_ITEMS,
      ...APPRAISAL_ITEMS,
      ...THEFT_ITEMS,
      ...SALVAGES_ITEMS,
      ...AUCTION_ITEMS,
      ...PROCESSING_ITEMS,
      ...INVESTIGATION_ITEMS,
      ...LITIGATION_ITEMS,
      ...CONFIG_ITEMS,
    ];

    effect(() => {
      this.userProfile = this.authService.profile();
    });
  }

  ngOnInit(): void {
    this.pageTitleService.getCurrentTitle().subscribe((title) => (this.title = title));
  }

  logout(): void {
    this.authService.logout();
  }

  setNavbarFolded(folded: boolean): void {
    this.navbarFolded = this.navbarOpen = folded;
  }

  setNavbarOpen(open: boolean): void {
    if (this.navbarFolded) {
      this.navbarOpen = open;
    }
  }
}
